import type { FoundationQuantitySchema } from "../types/project"

// Foundation quantity properties without id as it's generated
export const FOUNDATION_QUANTITY_PROPERTIES = [
  "Name",
  "Type",
  "Quantity",
  "Excavation",
  "PCC",
  "RCC",
  "Reinforcement MS steel",
  "Reinforcement HT steel",
]

/**
 * Gets all foundation quantity properties from the schema
 * @param schema The foundation quantity schema containing property definitions
 * @returns Array of property titles
 */
export const getAllFoundationQuantityProperties = (schema: FoundationQuantitySchema): string[] => {
  return FOUNDATION_QUANTITY_PROPERTIES
}